if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

// Returns the cart in JSON
Shopify.getCart = function (callback, ...params) {
  window
    .fetch("/cart.js", {
      credentials: "same-origin",
      method: "GET",
    })
    .then((response) => response.json())
    .then((cart) => callback(cart, ...params))
    .catch((error) => {
      throw new Error(error);
    });
};

var updateFreePromoMessage = (function () {
  const promoNotification = document.getElementById("promoNotification");
  const promoNotificationShipping = document.getElementById(
    "promoNotificationShipping"
  );
  if (document.querySelector("[data-fs-threshold]")) {
    var freeShippingThreshold = parseFloat(
      document
        .querySelector("[data-fs-threshold]")
        .getAttribute("data-fs-threshold")
    );
  }

  const promoNotificationGift = document.getElementById(
    "promoNotificationGift"
  );
  if (document.querySelector("[data-fg-threshold]")) {
    var freeGiftThreshold = parseFloat(
      document
        .querySelector("[data-fg-threshold]")
        .getAttribute("data-fg-threshold")
    );
    var freeGiftVariantId = parseFloat(
      document.querySelector("[data-fg-threshold]").getAttribute("data-gift-id")
    );
  }

  var onCartUpdateDisplay = function (cart, containerTextEl, messageType) {
    // console.log({cart});
    // console.log("onCartUpdateDIisplay() : "+messageType);

    let cartTotalPrice = cart.total_price;

    console.log({ cartTotalPrice });

    if (messageType == "shipping") {
      let hasSubscriptionInCart = cart.items.some(
        (item) => item.selling_plan_allocation != null
      );

      let totalPriceOfGiftCards = cart.items.reduce((total, item) => {
        return item.gift_card ? total + item.final_line_price : total;
      }, 0);
      cartTotalPrice = cartTotalPrice - totalPriceOfGiftCards;

      let isFreeShipping =
        cartTotalPrice >= freeShippingThreshold || hasSubscriptionInCart
          ? true
          : false;

      setNotificationStatus(
        isFreeShipping,
        "free-shipping",
        "earned-free-shipping"
      );

      if (sessionStorage.getItem("earned-free-shipping") == null) {
        promoNotificationShipping.classList.remove("hidden");
        containerTextEl.innerHTML = getShippingMessage(
          cartTotalPrice,
          hasSubscriptionInCart
        );
      } else {
        promoNotificationShipping.classList.add("hidden");
      }
    }

    if (messageType == "gift") {
      // let hasGiftInCart = cart.items.some(item => item.id == freeGiftVariantId); // TO ADD: Check if price is 0 which means, it's a gift

      let { cartTotalPrice, hasGiftInCart } = checkCartContent(cart),
        isFreeGift =
          cartTotalPrice >= freeGiftThreshold && hasGiftInCart ? true : false;

      // console.log("\n", {isFreeGift}, {hasGiftInCart}, {cartTotalPrice}, "\n");

      if (!isFreeGift) {
        setNotificationStatus(isFreeGift, "free-gift", "earned-free-gift");
      }

      if (
        sessionStorage.getItem("earned-free-gift") == null &&
        !hasGiftInCart
      ) {
        promoNotificationGift.classList.remove("hidden");
        containerTextEl.innerHTML = getGiftMessage(cartTotalPrice, false);
      } else {
        promoNotificationGift.classList.add("hidden"); // When gift is in cart, do not display the notification again
      }
      setNotificationStatus(isFreeGift, "free-gift", "earned-free-gift");
    }

    promoNotification.classList.add("active");
    setTimeout(() => {
      promoNotification.classList.remove("active");
    }, 3000);
  };

  var checkCartContent = function (cart) {
    let cartTotalPrice = cart.total_price,
      hasGiftInCart = false;

    cart.items.some(function (item, i) {
      if (item.id == freeGiftVariantId && item.final_line_price === 0) {
        // console.log("has gift priced 0");
        hasGiftInCart = true;
        cartTotalPrice = cart.total_price;
        return true;
      } else if (item.id == freeGiftVariantId && item.final_line_price > 0) {
        // console.log("has the regular priced gift item");
        hasGiftInCart = false;
        cartTotalPrice = cartTotalPrice - item.final_price;
      }

      if (item.gift_card) {
        cartTotalPrice = cartTotalPrice - item.final_line_price;
      }
    });

    return { cartTotalPrice, hasGiftInCart };
  };

  var getShippingMessage = function (totalPrice, hasSubscriptionInCart) {
    if (
      totalPrice >= freeShippingThreshold ||
      (typeof hasSubscriptionInCart !== "undefined" && hasSubscriptionInCart)
    ) {
      return "You have earned <span>FREE SHIPPING</span>";
    } else {
      let amountDifference =
        (freeShippingThreshold - parseFloat(totalPrice)) / 100.0;
      return (
        'You are <span class="amount"> £' +
        parseFloat(amountDifference).toFixed(2) +
        "</span> away from <span>FREE UK SHIPPING</span>"
      );
    }
  };

  var getGiftMessage = function (totalPrice, isCartPage) {
    // console.log("getGiftMessage()");
    // console.log({totalPrice});
    // console.log({freeGiftThreshold});
    if (totalPrice >= freeGiftThreshold) {
      if (isCartPage) {
        return "<span>FREE GIFT</span>";
      }
      return '<a href="/cart">Claim your <span><em>FREE GIFT</em></span> in cart page</a>';
    } else {
      let amountDifference =
        (freeGiftThreshold - parseFloat(totalPrice)) / 100.0;
      return (
        'Spend <span data-fg-add-amount class="amount"> £' +
        parseFloat(amountDifference).toFixed(2) +
        "</span> to claim your <span>FREE GIFT</span>"
      );
    }
  };

  /**
   * To store the state of free shipping/gift notification when threshold is met.
   * If true, do not display the notification again.
   *
   */
  var setNotificationStatus = function (conditionMet, initKey, key) {
    // console.log("set notification status");
    // console.log({conditionMet}, {initKey}, {key});
    if (conditionMet) {
      if (
        sessionStorage.getItem(initKey) &&
        sessionStorage.getItem(key) == null
      ) {
        sessionStorage.setItem(key, true);
      }
      if (sessionStorage.getItem(initKey) == null) {
        sessionStorage.setItem(initKey, true);
      }
    } else {
      if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(initKey);
        sessionStorage.removeItem(key);
      }
    }
    /*
    console.log("------- start setNotificationStatus ----");
    console.log(sessionStorage.getItem(key));
    console.log("------- end setNotificationStatus ----");
    */
  };

  var displayNotification = function (containerTextEl, messageType) {
    // check latest content of cart and and display
    Shopify.getCart(onCartUpdateDisplay, containerTextEl, messageType);
  };

  return {
    updateFreePromoMessage: updateFreePromoMessage,
    getShippingMessage: getShippingMessage,
    getGiftMessage: getGiftMessage,
    checkCartContent: checkCartContent,
    displayNotification: displayNotification,
  };
})();
